//import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
//import App from './App';

//import styles from './index.scss';
import reportWebVitals from './reportWebVitals';
import X from './X/XModule';
//import { EOrientation, ETheme } from './X/enums';
import { ETheme } from './X/types/enums';
import React from 'react';
import { EOrientation } from './X/types/enums';
import { XButton, XComboBox, XComboBoxItem, XProgressBar } from './X';
/// <reference path="X/components/basics/XButton.tsx" />
//import XButton = X.XButton from './X/components/basics/XButton';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
/*const style = {
  
}*/
const indexes: string[] = ['00', '11', '22', '33', '44', '55', '66', '77', '88', '99', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF'];
const cbi: JSX.Element[] = Array.from(Array(31).keys()).map((x, i) =>
  <XComboBoxItem key={i} value={`v${x}`} default={i===21}>
    {`test ${x}`}
  </XComboBoxItem>
);
// function CBI(): XComboBoxItem[] {
//   const cbi: XComboBoxItem = new XComboBoxItem({value: 'vv', children: 'tt'});
//   return( [cbi]
//   );
// }
root.render(
  <X.XApplication>
    <X.XMainForm>
      <X.XColumn>
        <X.XRow>
          <X.XImageLink padding='16px 34px 16px 34px' reference={""} source={'resource/logo/Legion_BladeMetal.png'} text={'XLegion'}/>
          <X.XStub/>
          <div style={{width: '305px'}}>
          <X.XColumn>
            <X.XRow>
              <X.XSeek/>
            </X.XRow>
            <X.XTable height="100%" width="100%">
                <X.XTableRow height="42px"/>
                <X.XTableRow>
                    <X.XTableCell width="100%"/>
                </X.XTableRow>
                <X.XTableRow height="9px">
                    <X.XTableCell width="100%" />
                </X.XTableRow>
                <X.XTableRow height="18px">
                    <X.XTableCell width="100%">
                        <X.XTable height="100%">
                            <X.XTableRow>
                                <X.XTableCell width="195px" />
                                <X.XTableCell width="70px">
                                    <span>Language</span>
                                </X.XTableCell>
                                <X.XTableCell width="25px" />
                                <X.XTableCell width="15px" />
                            </X.XTableRow>
                        </X.XTable>
                    </X.XTableCell>
                </X.XTableRow>
                <X.XTableRow height="5px">
                    <X.XTableCell width="100%" />
                </X.XTableRow>
            </X.XTable>            
          </X.XColumn>
          </div>
        </X.XRow>
        <X.XButtonsLine>
          <X.XBigButton isActive={true} text='Main Page'/>
          <X.XBigButton text='Downloads'/>
          <X.XBigButton text='Help/Dictionary'/>
          <X.XBigButton text='Forum'/>
          <X.XBigButton text='About/License'/>
        </X.XButtonsLine>
        <X.XContentForm>
          <X.XFrame>
            <X.XArticle header='Тест панель'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>
                <X.XRow>
                  <X.XPanel margin='5px' /*theme={ETheme.Blue}*/>
                    <X.XPanel margin='5px' orientation={EOrientation.Horizontal} /*theme={ETheme.Blue}*/>
                      <XButton margin={'1px'}>button 1</XButton>
                      <XButton margin={'1px'}>button 2</XButton>
                      <XButton margin={'1px'}>button 3</XButton>
                    </X.XPanel>
                    <X.XPanel margin='5px' orientation={EOrientation.Horizontal}>
                      <X.XPanel margin='5px' orientation={EOrientation.Vertical}>
                        <XButton></XButton>
                        <XButton></XButton>
                        <XButton></XButton>
                      </X.XPanel>
                      <X.XPanel margin='5px' orientation={EOrientation.Vertical}>
                        <XButton></XButton>
                        <XButton></XButton>
                        <XButton></XButton>
                      </X.XPanel>
                      <X.XPanel margin='5px' orientation={EOrientation.Vertical}>
                        <XButton></XButton>
                        <XButton></XButton>
                        <XButton></XButton>
                      </X.XPanel>
                      <X.XPanel margin='5px' orientation={EOrientation.Vertical}>
                        <XButton></XButton>
                        <XButton></XButton>
                        <XButton></XButton>
                      </X.XPanel>
                      <X.XPanel margin='5px' orientation={EOrientation.Vertical}>
                        <XButton></XButton>
                        <XButton></XButton>
                        <XButton></XButton>
                      </X.XPanel>
                    </X.XPanel>
                  </X.XPanel>
                </X.XRow>
            </X.XArticle> 
          </X.XFrame>
          <X.XFrame>
            <X.XArticle header='Тест канбан'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>
                <X.XRow>
                  <X.XKanban margin='5px' theme={ETheme.Blue}/>
                </X.XRow>
            </X.XArticle> 
          </X.XFrame>
          <X.XFrame>
            <X.XArticle header='Тест выпадающих списков'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>
                <X.XRow>
                  <XComboBox margin='5px' theme={ETheme.Blue} editable children={cbi}/>
                  <XComboBox margin='5px' theme={ETheme.Green} children={cbi}/>
                  <XComboBox seeker editable margin='5px' theme={ETheme.Red} children={cbi}/>
                </X.XRow>
                <X.XRow>
                  <XComboBox margin='5px' theme={ETheme.Yellow} children={cbi}/>
                  <XComboBox margin='5px' theme={ETheme.Gray} children={cbi}/>
                  <XComboBox margin='5px' theme={ETheme.LightGray} children={cbi}/>
                </X.XRow>
                <X.XRow>
                  <XComboBox margin='5px' theme={ETheme.White} children={cbi}/>
                  <XComboBox margin='5px' theme={ETheme.Green} children={cbi}/>
                  <XComboBox margin='5px' theme={ETheme.Red} seeker children={cbi}/>
                </X.XRow>
            </X.XArticle> 
          </X.XFrame>
          <X.XFrame>
            <X.XArticle header='Тест полей редактирования'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>
                <X.XRow>
                  <X.XTextEdit margin='5px' theme={ETheme.Blue}/>
                  <X.XTextEdit margin='5px' theme={ETheme.Green}/>
                  <X.XTextEdit margin='5px' theme={ETheme.Red}/>
                </X.XRow>
                <X.XRow>
                  <X.XTextEdit margin='5px' theme={ETheme.Yellow}/>
                  <X.XTextEdit margin='5px' theme={ETheme.Gray}/>
                  <X.XTextEdit margin='5px' theme={ETheme.LightGray}/>
                </X.XRow>
                <X.XRow>
                  <X.XTextEdit margin='5px' theme={ETheme.White}/>
                  <X.XTextEdit margin='5px' theme={ETheme.Green}/>
                  <X.XTextEdit margin='5px' theme={ETheme.Red}/>
                </X.XRow>
            </X.XArticle> 
          </X.XFrame>
          <X.XFrame>
            <X.XArticle
              header='Тест табов'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>
              <X.XTabPanel>
                <X.XTab header='Tab1'></X.XTab>
                <X.XTab header='Tab2'></X.XTab>
                <X.XTab header='Tab3'></X.XTab>
                <X.XTab header='Tab4'></X.XTab>
              </X.XTabPanel>
            </X.XArticle> 
          </X.XFrame>
          <X.XFrame>
            <X.XArticle
              header='Тест прогресса'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>
              <XProgressBar value={10} infinity theme={ETheme.Green} formated='бесконечный процесс'/>
              <XProgressBar value={61} theme={ETheme.Red}/>
              <XProgressBar value={61} maximum={200}/>
              <XProgressBar value={83} maximum={300} isPercent theme={ETheme.Gray} formated={'Загрузка файлов завершена на {0}!'}/>
            </X.XArticle> 
          </X.XFrame>
          <X.XFrame>
            <X.XArticle
              header='Тест окон'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>                
              </>)}>                

              <X.XRow margin='5px'>
                <XButton theme={ETheme.Yellow} children='Палитры' onClick={(owner: XButton) =>{
                  X.XWindow.showModal((dialog) =>
                    <X.XWindow header='Палитры' dialog={dialog}>
                      <X.XColumn>
                        {React.Children.map(indexes, (i) => 
                          <X.XRow>
                              <XButton theme={ETheme.Red} children={'Палитра ' + i} onClick={() => {
                                X.XWindow.showModal((dialog) =>
                                  <X.XWindow header='Палитра' dialog={dialog}>
                                    <X.XColumn>
                                      <X.XRow margin='0'><X.XPalette isRed part={i}/></X.XRow>
                                      <X.XRow><XButton onClick={()=>{X.XWindow.close(dialog)}}>close</XButton></X.XRow>
                                    </X.XColumn>                        
                                  </X.XWindow>
                              );
                              }}/>
                              <XButton theme={ETheme.Green} children={'Палитра ' + i} onClick={() => {
                                X.XWindow.showModal((dialog) =>
                                  <X.XWindow header='Палитра' dialog={dialog}>
                                    <X.XColumn>
                                      <X.XRow><X.XPalette isGreen part={i}/></X.XRow>
                                      <X.XRow><XButton onClick={()=>{X.XWindow.close(dialog)}}>close</XButton></X.XRow>
                                    </X.XColumn>                        
                                  </X.XWindow>
                              );
                              }}/>
                              <XButton children={'Палитра ' + i} onClick={() => {
                                X.XWindow.showModal((dialog) =>
                                  <X.XWindow header='Палитра' dialog={dialog}>
                                    <X.XColumn>
                                      <X.XRow><X.XPalette isBlue part={i}/></X.XRow>
                                      <X.XRow><XButton closeDialog /*onClick={()=>{X.XWindow.close(dialog)}}*/>close</XButton></X.XRow>
                                    </X.XColumn>                        
                                  </X.XWindow>
                              );
                              }}/>
                          </X.XRow>
                        )}
                        <XButton onClick={()=>{X.XWindow.close(dialog)}}>close</XButton>
                      </X.XColumn>
                      
                    </X.XWindow>
                );
                }}/>
              </X.XRow>
              <X.XRow margin='5px'>
                <XButton theme={ETheme.Gray} children='Модальное окно' onClick={(owner: XButton) =>{
                  X.XWindow.showModal((dialog) =>
                    <X.XWindow header='Модальное окно' dialog={dialog}>
                      <XButton onClick={()=>{X.XWindow.close(dialog)}}>close</XButton>
                    </X.XWindow>
                );
                }}/>
              </X.XRow>
            </X.XArticle>
          </X.XFrame>  
          <X.XFrame>
            <X.XArticle
              header='Кнопки'
              stickers={
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Компоненты</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>В процессе</X.XArticleSticker>
              </>
            }>
              <X.XColumn>
                <X.XRow>
                  <XButton margin='5px' theme={ETheme.Blue}>text</XButton>
                  <XButton margin='5px' theme={ETheme.Green}>text</XButton>
                  <XButton margin='5px' theme={ETheme.Red}>text</XButton>
                </X.XRow>
                <X.XRow>
                  <XButton margin='5px' theme={ETheme.Yellow}>text</XButton>
                  <XButton margin='5px' theme={ETheme.Gray}>text</XButton>
                  <XButton margin='5px' theme={ETheme.LightGray}>text</XButton>
                </X.XRow>
              </X.XColumn>
            </X.XArticle>
          </X.XFrame>
          <X.XFrame>
            <X.XArticle
              header='Тест наклеек'
              stickers={(
              <>
                <X.XArticleSticker theme={ETheme.Blue}>Новости</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Red}>Горячие новости</X.XArticleSticker>
                <X.XArticleSticker theme={ETheme.Green}>Просмотр разрешён</X.XArticleSticker>
              </>)}>
              Переработал переработал внутринности в ООП формате
              <br />Убрал кучу лишних функций
              <br />Переработал Статью
              <br />Теперь используется реакт
              <br />Строка случайная
            </X.XArticle>
          </X.XFrame>          
        </X.XContentForm>
        {/* <div style={{height: '38px'}}/>         */}
        {/* <X.Stub/>        Тело формы */}
        {/* <div style={{height: '26px'}}/> */}
      </X.XColumn>      
  </X.XMainForm>
</X.XApplication>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
